(function () {
  function initSignupToggle(root) {
    var toggle = root.querySelector('[data-vny-signup-toggle]');
    var input = root.querySelector('[data-vny-signup-input]');
    var prefix = root.querySelector('[data-vny-signup-prefix]');
    var subline = root.querySelector('[data-vny-signup-subline]');
    var consent = root.querySelector('[data-vny-signup-consent]');
    var tagsField = root.querySelector('[data-vny-signup-tags]');
    var hiddenField = root.querySelector('[data-vny-signup-hidden-field]');
    var form = root.querySelector('form');

    if (!toggle || !input || !hiddenField) return;

    function setMode(mode) {
      root.setAttribute('data-mode', mode);

      if (mode === 'email') {
        input.type = 'email';
        input.inputMode = '';
        input.autocomplete = 'email';
        input.placeholder = input.getAttribute('data-email-placeholder') || '';
        if (prefix) prefix.style.display = 'none';
      } else {
        input.type = 'tel';
        input.inputMode = 'numeric';
        input.autocomplete = 'tel';
        input.placeholder = input.getAttribute('data-phone-placeholder') || '';
        if (prefix) prefix.style.display = '';
      }

      [subline, consent, toggle].forEach(function (el) {
        if (!el) return;
        var text = el.getAttribute(mode === 'email' ? 'data-email-text' : 'data-phone-text');
        var label = el.getAttribute(mode === 'email' ? 'data-email-label' : 'data-phone-label');
        if (text) el.textContent = text;
        if (label) el.textContent = label;
      });

      if (tagsField) tagsField.value = mode === 'email' ? 'newsletter' : 'whatsapp';
      input.value = '';
    }

    toggle.addEventListener('click', function () {
      var nextMode = root.getAttribute('data-mode') === 'email' ? 'phone' : 'email';
      setMode(nextMode);
      input.focus();
    });

    if (form) {
      form.addEventListener('submit', function () {
        var mode = root.getAttribute('data-mode');
        if (mode === 'email') {
          hiddenField.name = 'contact[email]';
          hiddenField.value = input.value;
        } else {
          hiddenField.name = 'contact[phone]';
          var prefixText = prefix ? prefix.textContent.trim() : '';
          hiddenField.value = (prefixText + input.value).replace(/[^\d+]/g, '');
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-vny-footer-signup]').forEach(initSignupToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
